import Products from './Products.vue'

export default Products
